/* eslint eqeqeq: "off" */
import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import PropTypes from "prop-types";
import {
  Col,
  Row,
  Skeleton,
  Select,
  Table,
  AutoComplete,
  Input,
  Spin,
  Badge,
} from "antd";
import "./index.css";
import { DownloadOutlined } from "@ant-design/icons";
import { BiCalendar } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { isEmpty } from "lodash";
import useMedia from "use-media-antd-query";
import {
  loadExpensesCategories,
  loadExpensesItemList,
  loadExpensesListRecordsMetaData,
  loadExpensesReportList,
} from "../../store/expenses/actions";
import DatePicker from "react-datepicker";
import api from "../../helpers";
import { toast, ToastContainer } from "react-toastify";

const ExpensesReport = (props) => {
  const dispatch = useDispatch();

  //organisation id from login response
  const userValues = localStorage.getItem("authData");

  const userNameDetails = JSON.parse(userValues);

  const organizationId =
    !isEmpty(userNameDetails) &&
    userNameDetails.user &&
    userNameDetails.user.organizations.length > 0
      ? userNameDetails.user.organizations[0].organizationId
      : "";

  const media = useMedia();

  const stockGetPayload = {
    organizationId: organizationId,
    page: 1,
    limit: 10,
  };

  //initial state values
  const [loading, setLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [itemList, setItemList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [paymentModeList, setPaymentModeList] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [downloadLoading, setDownloadLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
      setLoading(false);
    }, 2000);
    dispatch(loadExpensesReportList(stockGetPayload));
    dispatch(loadExpensesCategories(stockGetPayload));
    dispatch(loadExpensesItemList(stockGetPayload));
    dispatch(loadExpensesListRecordsMetaData());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // reducer state
  const {
    expenses_report_list = {},
    expenses_categories_list = {},
    expenses_item_list = {},
    expenseMetaData = {},
  } = useSelector((state) => state.Expenses);

  const itemOptions =
    expenses_item_list && expenses_item_list.length > 0
      ? expenses_item_list.map((data) => {
          return { value: data._id, label: data.itemName };
        })
      : [];
  const categoryOptions =
    expenses_categories_list && expenses_categories_list.length > 0
      ? expenses_categories_list.map((data) => {
          return { value: data._id, label: data.expenseName };
        })
      : [];

  //header columns
  const HeaderData = [
    {
      key: "expenseDate",
      title: <p className="header-purchase-invoice font-semibold">Date</p>,
      dataIndex: "expenseDate",
      width: 120,
      // fixed: "left",
      render: (row, text) => (
        <p
          className="ml-1"
          style={{
            fontFamily: "Poppins",
            fontSize: "12px",
          }}
        >
          {text.expenseDate && text.expenseDate}
        </p>
      ),
      sorter: (a, b) => a.expenseDate.length - b.expenseDate.length,
    },
    {
      key: "expenseNo",
      title: (
        <p className="header-purchase-invoice font-semibold">Expense No</p>
      ),
      dataIndex: "expenseNo",
      width: 115,
    },
    {
      key: "expenseItem",
      title: (
        <p className="header-purchase-invoice font-semibold">Expense Items</p>
      ),
      dataIndex: "expenseItem",
      width: 130,
    },
    {
      key: "isexpenseWithGST",
      title: (
        <p className="header-purchase-invoice font-semibold">
          Expense With GST
        </p>
      ),
      dataIndex: "isexpenseWithGST",
      render: (record, text, row) => (
        <Badge
          className={
            text.isexpenseWithGST &&
            text.isexpenseWithGST &&
            text.isexpenseWithGST === true
              ? "bg-[#edf6ef] font-semibold header-sales-invoice rounded-md text-[#49a563] text-[12px] p-2"
              : "bg-[#f1e7e9] font-semibold header-sales-invoice rounded-md text-[#d01717] text-[12px] p-2"
          }
          // onClick={() => paymentInvoiceRoutes(text)}
        >
          {text.isexpenseWithGST && text.isexpenseWithGST === true
            ? "YES"
            : "NO"}
        </Badge>
      ),
      width: 150,
    },
    {
      key: "partyName",
      title: (
        <p className="header-purchase-invoice font-semibold">Party Name</p>
      ),
      render: (row, text) => (
        <p
          className="ml-1"
          style={{
            fontFamily: "Poppins",
            fontSize: "12px",
          }}
        >
          {text.partyName && text.partyName}
        </p>
      ),
      dataIndex: "partyName",
      width: 150,
    },
    {
      key: "categoryName",
      title: <p className="header-purchase-invoice font-semibold">Category</p>,
      dataIndex: "categoryName",
      render: (record, text, row) => (
        <p className="header-purchase-invoice">{text.categoryName}</p>
      ),
      width: 140,
    },
    {
      key: "paymentModeName",
      title: (
        <p className="header-purchase-invoice font-semibold">Payment Mode</p>
      ),
      dataIndex: "paymentModeName",
      render: (record, text, row) => (
        <p className="header-purchase-invoice">{text.paymentModeName}</p>
      ),
      width: 140,
    },
    {
      key: "itemsTotalAmount",
      title: (
        <p className="header-purchase-invoice font-semibold">Item Amount</p>
      ),
      dataIndex: "itemsTotalAmount",
      render: (record, text, row) => (
        <div className="flex">
          <p>{"₹ "}</p>
          <p className="header-purchase-invoice cursor-pointer ml-1">
            {text.itemsTotalAmount &&
              text.itemsTotalAmount.toLocaleString("en-IN")}
          </p>
        </div>
      ),
      width: 130,
    },
    {
      key: "itemsTotalDiscount",
      title: <p className="header-purchase-invoice font-semibold">Discount</p>,
      dataIndex: "itemsTotalDiscount",
      render: (record, text, row) => (
        <div className="flex">
          <p>{"₹ "}</p>
          <p className="header-purchase-invoice cursor-pointer ml-1">
            {text.itemsTotalDiscount &&
              text.itemsTotalDiscount.toLocaleString("en-IN")}
          </p>
        </div>
      ),
      width: 130,
    },
    {
      key: "itemsTotalTax",
      title: (
        <p className="header-purchase-invoice font-semibold">Tax Amount</p>
      ),
      dataIndex: "itemsTotalTax",
      render: (record, text, row) => (
        <div className="flex">
          <p>{"₹ "}</p>
          <p className="header-purchase-invoice cursor-pointer ml-1">
            {text.itemsTotalTax && text.itemsTotalTax.toLocaleString("en-IN")}
          </p>
        </div>
      ),
      width: 130,
    },
    {
      key: "totalAmount",
      title: <p className="header-purchase-invoice font-semibold">Total</p>,
      dataIndex: "totalAmount",
      render: (record, text, row) => (
        <div className="flex">
          <p>{"₹ "}</p>
          <p className="header-purchase-invoice cursor-pointer ml-1">
            {text.totalAmount && text.totalAmount.toLocaleString("en-IN")}
          </p>
        </div>
      ),
      width: 130,
    },
    {
      key: "status",
      title: <p className="header-purchase-invoice font-semibold">Status</p>,
      dataIndex: "status",
      width: 130,
    },
  ];

  //filters
  const [pageValue, setPageValue] = useState("");
  const [filteredValues, setFilteredValues] = useState("");
  const applyFilters = () => {
    var fromDateFilter = fromDate ? moment(fromDate).format("YYYY-MM-DD") : "";
    var toDateFilter = toDate ? moment(toDate).format("YYYY-MM-DD") : "";
    var expenseItemId =
      !isEmpty(itemList) || itemList.length !== 0 ? itemList : "";
    var categoryId =
      !isEmpty(categoryList) || categoryList.length !== 0 ? categoryList : "";
    var paymentModeId =
      !isEmpty(paymentModeList) || paymentModeList.length !== 0
        ? paymentModeList
        : "";

    let searchValue = {};
    searchValue.page = pageValue ? pageValue : 1;
    searchValue.limit = 10;
    searchValue.organizationId = organizationId;

    if (fromDateFilter) {
      searchValue.fromDate = fromDateFilter;
    }
    if (toDateFilter) {
      searchValue.toDate = toDateFilter;
    }
    if (categoryId) {
      searchValue.categoryId = categoryId;
    }
    if (expenseItemId) {
      searchValue.expenseItemId = expenseItemId;
    }
    if (paymentModeId) {
      searchValue.paymentModeId = paymentModeId;
    }
    const searchFilterValues = Object.keys(searchValue).forEach(
      (data) => !searchValue[data] && delete searchValue[data]
    );
    console.log(searchFilterValues, "searchFilterValues");

    setFilteredValues(searchValue);
    setTableLoading(true);
    dispatch(loadExpensesReportList(searchValue));
    setTimeout(() => {
      setTableLoading(false);
    }, 2000);
  };

  const [expenseRows, setExpenseRows] = useState([
    {
      expenseDate: "",
      expenseNo: "",
      isexpenseWithGST: "",
      partyName: "",
      expenseItem: "",
      accountName: "",
      additionalCharges: "",
      categoryId: "",
      categoryName: "",
      createdBy: "",
      itemsTotalAmount: "",
      itemsTotalDiscount: "",
      itemsTotalTax: "",
      totalAmount: "",
      notes: "",
      orginalInvoiceNo: "",
      paymentModeId: "",
      paymentModeName: "",
      _id: "",
      status: "",
    },
  ]);

  console.log(expenses_report_list, "expenses_report_list");
  const expensesDataTable =
    !isEmpty(expenses_report_list) &&
    expenses_report_list.expenseItems.length > 0
      ? expenses_report_list.expenseItems.map((data, index) => {
          return {
            key: index + 1,
            expenseDate: data.expenseDate
              ? moment(data.expenseDate).format("DD-MM-YYYY")
              : "",
            expenseNo: data.expenseNo,
            isexpenseWithGST: data.isexpenseWithGST,
            partyName: data.partyName,
            expenseItem:
              data.expenseItem.length > 0 ? data.expenseItem.length : 0,
            accountName: data.accountName,
            additionalCharges: data.additionalCharges,
            categoryId: data.categoryId,
            categoryName: data.categoryName,
            createdBy: data.createdBy,
            itemsTotalAmount: data.itemsTotalAmount,
            totalAmount: data.totalAmount,
            itemsTotalDiscount: data.itemsTotalDiscount,
            itemsTotalTax: data.itemsTotalTax,
            notes: data.notes,
            orginalInvoiceNo: data.orginalInvoiceNo,
            paymentModeId: data.paymentModeId,
            paymentModeName: data.paymentModeName,
            _id: data._id,
            status: (
              <Badge
                style={{
                  fontFamily: "Poppins",
                }}
                className={
                  data.status &&
                  data.status.length > 0 &&
                  data.status[0].statusName === "Active"
                    ? "bg-[#edf6ef] font-semibold capitalize rounded-md text-[#49a563] p-2"
                    : "bg-[#f1e7e9] font-semibold capitalize rounded-md text-[#d01717] p-2"
                }
              >
                {data.status &&
                  data.status.length > 0 &&
                  data.status[0].statusName}
              </Badge>
            ),
          };
        })
      : [];

  useEffect(() => {
    if (expensesDataTable && expensesDataTable.length > 0) {
      setExpenseRows(expensesDataTable);
    } else {
      setExpenseRows([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expenses_report_list]);

  //paginations
  const handlePagination = (data) => {
    const filter = {
      page: data,
      limit: 10,
      organizationId: organizationId,
      paymentModeId: filteredValues ? filteredValues.paymentModeId : "",
      categoryId: filteredValues ? filteredValues.categoryId : "",
      expenseItemId: filteredValues ? filteredValues.expenseItemId : "",
      fromDate: filteredValues ? filteredValues.fromDate : "",
      toDate: filteredValues ? filteredValues.toDate : "",
    };
    const searchFilterValues = Object.keys(filter).forEach(
      (data) => !filter[data] && delete filter[data]
    );
    console.log(searchFilterValues, "searchFilterValues");
    console.log(filter, "filter");
    setPageValue(data);
    dispatch(loadExpensesReportList(filter));
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
    }, 2000);
  };

  //search , print and download
  const [search, setSearch] = useState("");

  const handleSearch = (event) => {
    const filteredRows = expensesDataTable
      .filter((row) =>
        row.categoryName
          .toLowerCase()
          .includes(event.target.value.toLowerCase())
      )
      .filter((item, index, self) => self.indexOf(item) === index); // Remove duplicates

    setSearch(event.target.value);
    setExpenseRows(filteredRows);
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
    }, 2000);
  };

  //Download functionality

  //Download functionality
  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType });

    const a = document.createElement("a");
    a.download = fileName;
    a.href = window.URL.createObjectURL(blob);
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    });
    a.dispatchEvent(clickEvt);
    a.remove();
  };

  const handleDownloadPDF = () => {
    setDownloadLoading(true);
    var fromDateFilter = fromDate ? moment(fromDate).format("YYYY-MM-DD") : "";
    var toDateFilter = toDate ? moment(toDate).format("YYYY-MM-DD") : "";
    var expenseItemId =
      !isEmpty(itemList) || itemList.length !== 0 ? itemList : "";
    var categoryId =
      !isEmpty(categoryList) || categoryList.length !== 0 ? categoryList : "";
    var paymentModeId =
      !isEmpty(paymentModeList) || paymentModeList.length !== 0
        ? paymentModeList
        : "";

    let searchValue = {};
    searchValue.organizationId = organizationId;

    if (fromDateFilter) {
      searchValue.fromDate = fromDateFilter;
    }
    if (toDateFilter) {
      searchValue.toDate = toDateFilter;
    }
    if (expenseItemId) {
      searchValue.expenseItemId = expenseItemId;
    }
    if (categoryId) {
      searchValue.categoryId = categoryId;
    }
    if (paymentModeId) {
      searchValue.paymentModeId = paymentModeId;
    }
    const searchFilterValues = Object.keys(searchValue).forEach(
      (data) => !searchValue[data] && delete searchValue[data]
    );
    console.log(searchFilterValues, "searchFilterValues");

    api
      .post(`/org/getexpensereportexcel`, searchValue)
      .then((response) => {
        const stockReportExcel =
          !isEmpty(response) && response.data.length > 0
            ? response.data.map((data, index) => {
                return {
                  key: index + 1,
                  expenseDate: data.expenseDate
                    ? moment(data.expenseDate).format("DD-MM-YYYY")
                    : "",
                  expenseNo: data.expenseNo,
                  isexpenseWithGST:
                    data.isexpenseWithGST === true ? "YES" : "NO",
                  partyName: data.partyName,
                  expenseItem: data.expenseItem,
                  accountName: data.accountName,
                  additionalCharges: data.additionalCharges,
                  categoryId: data.categoryId,
                  categoryName: data.categoryName,
                  createdBy: data.createdBy,
                  itemsTotalAmount: data.itemsTotalAmount,
                  itemsTotalDiscount: data.itemsTotalDiscount,
                  itemsTotalTax: data.itemsTotalTax,
                  totalAmount: data.totalAmount,
                  notes: data.notes,
                  orginalInvoiceNo: data.orginalInvoiceNo,
                  paymentModeId: data.paymentModeId,
                  paymentModeName: data.paymentModeName,
                  _id: data._id,
                  status:
                    data.status &&
                    data.status.length > 0 &&
                    data.status[0].statusName,
                };
              })
            : [];
        setTimeout(() => {
          let headerData = [
            "S.No, Date,Expense No,Expense With Gst,Party Name, Category,Payment Mode, Item Amount, Discount, Tax, Total Amount, Status",
          ];

          let usersCsv = !isEmpty(stockReportExcel)
            ? stockReportExcel.reduce((acc, user) => {
                const {
                  key,
                  expenseDate,
                  expenseNo,
                  isexpenseWithGST,
                  partyName,
                  categoryName,
                  paymentModeName,
                  itemsTotalAmount,
                  itemsTotalDiscount,
                  itemsTotalTax,
                  totalAmount,
                  status,
                } = user;
                acc.push([
                  key,
                  expenseDate,
                  expenseNo,
                  isexpenseWithGST,
                  partyName,
                  paymentModeName,
                  categoryName,
                  itemsTotalAmount,
                  itemsTotalDiscount,
                  itemsTotalTax,
                  totalAmount,
                  status,
                ]);

                return acc;
              }, [])
            : false;

          const usersList =
            !isEmpty(usersCsv) && usersCsv.length > 0 ? usersCsv : [];

          downloadFile({
            data: [...headerData, ...usersList].join("\n"),
            fileName: "ExpensesReport.csv",
            fileType: "text/csv",
          });
          setDownloadLoading(false);
        }, 2500);
        return response.data;
      })
      .catch((error) => {
        const errorMsg =
          (error &&
            error.response &&
            error.response.data &&
            error.response.data.message) ||
          (error &&
            error.response &&
            error.response.data &&
            error.response.data.error);
        toast.error(errorMsg);
        setDownloadLoading(false);
        Promise.reject(error);
      });
  };

  //window height/width
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Expenses Report | Mbook</title>
        </MetaTags>
      </div>

      <Row className="border-solid rounded-sm bg-[#ffffff]">
        <Col span={24}>
          <div className="font-poppins border border-b-1 border-x-0 border-t-0 pl-[20px] pr-[20px] mt-2 pb-2">
            <div className="flex">
              <h1
                style={{
                  fontFamily: "Poppins",
                }}
                className="text-[16px] font-semibold"
              >
                Expenses Report
              </h1>
            </div>
          </div>
        </Col>
      </Row>
      <Row
        className={
          (windowDimensions.height >= 700 && windowDimensions.height <= 767) ||
          (windowDimensions.height > 767 && windowDimensions.height < 830)
            ? "add-ledger-statment-reports-large-device"
            : windowDimensions.height > 830 && windowDimensions.height < 1000
            ? "add-ledger-statment-reports-extra-large-device"
            : windowDimensions.height > 1000
            ? "add-expenses-statment-reports-extra-large-device"
            : "add-ledger-statment-reports"
        }
      >
        <Col
          md={24}
          lg={24}
          sm={24}
          xs={24}
          className={
            (media === "md" ||
              media === "lg" ||
              media === "xl" ||
              media === "xxl") &&
            windowDimensions.height > 700
              ? "mt-2 pr-4 pl-4 pt-3 mb-4 bg-[#ffffff] h-[27%] rounded-md"
              : (media == "sm" || media == "xs") &&
                windowDimensions.height > 700
              ? "mt-2 pr-4 pl-4 pt-3 mb-4 h-[55%] pb-[20px] bg-[#ffffff] rounded-md"
              : "mt-2 pr-4 pl-4 pt-3 pb-2 mb-4 bg-[#ffffff] rounded-md"
          }
        >
          <Row
            className={
              windowDimensions.height > 700
                ? "pr-2 pl-2 pt-3 rounded-md"
                : "pr-2 pl-2 pt-3 pb-2 rounded-md"
            }
          >
            <Col
              md={6}
              lg={6}
              sm={24}
              xs={24}
              className={media == "sm" || media == "xs" ? "mt-2 pr-3" : "pr-3"}
            >
              {loading ? (
                <Skeleton.Input
                  style={{
                    width:
                      media == "md"
                        ? "180px"
                        : media == "sm"
                        ? "300px"
                        : "250px",
                    height: "35px",
                  }}
                ></Skeleton.Input>
              ) : (
                <Select
                  value={itemList}
                  onChange={(newValue) => setItemList(newValue)}
                  placeholder="Select Item"
                  options={itemOptions}
                  style={{
                    fontFamily: "Poppins",
                  }}
                  className={
                    media == "sm"
                      ? "w-[366px] h-[40px]"
                      : media == "xs"
                      ? "w-[230px] h-[40px]"
                      : "w-[100%] h-[40px]"
                  }
                />
              )}
            </Col>
            <Col
              md={6}
              lg={6}
              sm={24}
              xs={24}
              className={media == "sm" || media == "xs" ? "mt-2 pr-3" : "pr-3"}
            >
              {loading ? (
                <Skeleton.Input
                  style={{
                    width:
                      media == "md"
                        ? "180px"
                        : media == "sm"
                        ? "300px"
                        : "250px",
                    height: "35px",
                  }}
                ></Skeleton.Input>
              ) : (
                <Select
                  value={categoryList}
                  onChange={(newValue) => setCategoryList(newValue)}
                  placeholder="Select Category"
                  options={categoryOptions}
                  style={{
                    fontFamily: "Poppins",
                  }}
                  className={
                    media == "sm"
                      ? "w-[366px] h-[40px]"
                      : media == "xs"
                      ? "w-[230px] h-[40px]"
                      : "w-[100%] h-[40px]"
                  }
                />
              )}
            </Col>
            <Col
              md={6}
              lg={6}
              sm={24}
              xs={24}
              className={media == "sm" || media == "xs" ? "mt-2 pr-3" : "pr-3"}
            >
              {loading ? (
                <Skeleton.Input
                  style={{
                    width:
                      media == "md"
                        ? "180px"
                        : media == "sm"
                        ? "300px"
                        : "250px",
                    height: "35px",
                  }}
                ></Skeleton.Input>
              ) : (
                <Select
                  value={paymentModeList}
                  onChange={(newValue) => setPaymentModeList(newValue)}
                  placeholder="Select Payment Mode"
                  options={
                    expenseMetaData ? expenseMetaData.paymentModeOptions : []
                  }
                  style={{
                    fontFamily: "Poppins",
                  }}
                  className={
                    media == "sm"
                      ? "w-[366px] h-[40px]"
                      : media == "xs"
                      ? "w-[230px] h-[40px]"
                      : "w-[100%] h-[40px]"
                  }
                />
              )}
            </Col>
            <Col
              md={6}
              lg={6}
              sm={24}
              xs={24}
              className={media == "sm" || media == "xs" ? "mt-2 pr-3" : "pr-3"}
            >
              {loading ? (
                <Skeleton.Input
                  style={{
                    width:
                      media == "md"
                        ? "180px"
                        : media == "sm"
                        ? "300px"
                        : "250px",
                    height: "35px",
                    marginBottom: media == "sm" || media == "xs" ? "5px" : "",
                  }}
                ></Skeleton.Input>
              ) : (
                <DatePicker
                  selected={fromDate}
                  className={
                    media == "sm"
                      ? "rounded-md border border-1 h-[40px] w-[200%] mt-2"
                      : media == "xs"
                      ? "rounded-md border border-1 h-[40px] w-[125%] mt-2"
                      : media == "lg" || media == "md"
                      ? "rounded-md border border-1 h-[40px] w-[100%]"
                      : "rounded-md border border-1 h-[40px] w-[130%]"
                  }
                  toggleCalendarOnIconClick={true}
                  style={{
                    fontFamily: "Poppins",
                  }}
                  onChange={(date) => setFromDate(date)}
                  icon={
                    <BiCalendar
                      //   size={30}
                      className={
                        media == "sm"
                          ? "top-[12px] text-[16px] right-[-183px] text-[#9e9e9e]"
                          : media == "xs"
                          ? "top-[12px] text-[16px] right-[-30px] text-[#9e9e9e]"
                          : media == "lg" || media == "md"
                          ? "top-[5px] text-[16px] right-[3px] text-[#9e9e9e]"
                          : "top-[5px] text-[16px] right-[-50px]  text-[#9e9e9e]"
                      }
                    />
                  }
                  popperClassName={"z-10 ml-3"}
                  showIcon
                  placeholderText="Select From Date"
                />
              )}
            </Col>
            <Col
              md={6}
              lg={6}
              sm={24}
              xs={24}
              className={media == "sm" || media == "xs" ? "mt-2 pr-3" : "pr-3"}
            >
              {loading ? (
                <Skeleton.Input
                  style={{
                    width:
                      media == "md"
                        ? "180px"
                        : media == "sm"
                        ? "300px"
                        : "250px",
                    height: "35px",
                    marginBottom: media == "sm" || media == "xs" ? "5px" : "",
                    marginTop: media == "sm" || media == "xs" ? "5px" : "10px",
                  }}
                ></Skeleton.Input>
              ) : (
                <DatePicker
                  selected={toDate}
                  className={
                    media == "sm"
                      ? "rounded-md border border-1 h-[40px] w-[200%] mt-2"
                      : media == "xs"
                      ? "rounded-md border border-1 h-[40px] w-[125%] mt-2"
                      : media == "lg" || media == "md"
                      ? "rounded-md border border-1 h-[40px] w-[100%] mt-3"
                      : "rounded-md border border-1 h-[40px] w-[130%] mt-3"
                  }
                  toggleCalendarOnIconClick={true}
                  style={{
                    fontFamily: "Poppins",
                  }}
                  popperClassName={"z-10 ml-3"}
                  onChange={(date) => setToDate(date)}
                  icon={
                    <BiCalendar
                      //   size={30}
                      className={
                        media == "sm"
                          ? "top-[12px] text-[16px] right-[-183px] text-[#9e9e9e]"
                          : media == "xs"
                          ? "top-[12px] text-[16px] right-[-30px] text-[#9e9e9e]"
                          : media == "lg" || media == "md"
                          ? "top-[15px] text-[16px] right-[3px] text-[#9e9e9e]"
                          : "top-[15px] text-[16px] right-[-50px]  text-[#9e9e9e]"
                      }
                    />
                  }
                  showIcon
                  placeholderText="Select To Date"
                />
              )}
            </Col>
            <Col
              md={24}
              lg={24}
              sm={24}
              xs={24}
              className={
                media == "sm" || media == "xs"
                  ? "pr-2 w-[100%] mt-3"
                  : "pr-2 mt-3"
              }
            >
              <Row
                className={
                  media == "sm" || media == "xs" ? "flex" : "flex justify-end"
                }
              >
                {/* <Col
                  md={12}
                  lg={12}
                  sm={24}
                  xs={24}
                  className="pl-0 md:pl-10 lg:pl-10 xl:pl-10"
                > */}
                {loading ? (
                  <Skeleton.Input
                    style={{
                      width:
                        media == "md"
                          ? "180px"
                          : media == "sm"
                          ? "300px"
                          : "250px",
                      height: "35px",
                    }}
                  ></Skeleton.Input>
                ) : (
                  <div
                    className={
                      media == "sm" || media == "xs" ? "flex w-[100%]" : "flex"
                    }
                  >
                    <div
                      style={{
                        fontFamily: "Poppins",
                        fontSize: "13px",
                      }}
                      onClick={() => {
                        setFromDate("");
                        setToDate("");
                        setItemList([]);
                        setPaymentModeList([]);
                        setCategoryList([]);
                        setTableLoading(true);
                        setTimeout(() => {
                          setTableLoading(false);
                        }, 2000);
                        dispatch(loadExpensesReportList(stockGetPayload));
                      }}
                      className={
                        media == "sm" || media == "xs"
                          ? "cursor-pointer ml-0 text-[#ffffff] text-center rounded-md pt-2 pb-2 pl-5 pr-5 mr-2 bg-[#eb4d1b] hover hover:bg-[red]"
                          : "cursor-pointer ml-5 text-[#ffffff] text-center rounded-md pt-2 pb-2 pl-5 pr-5 mr-2 bg-[#eb4d1b] hover hover:bg-[red]"
                      }
                    >
                      Reset
                    </div>
                    <div
                      style={{
                        fontFamily: "Poppins",
                        fontSize: "13px",
                      }}
                      onClick={() => applyFilters()}
                      className="cursor-pointer ml-1 text-[#ffffff] text-center rounded-md pt-2 pb-2 pl-5 pr-5 bg-[#45bd4a] hover hover:bg-[green]"
                    >
                      Filter
                    </div>
                  </div>
                )}
                {/* </Col> */}
              </Row>
            </Col>
          </Row>
        </Col>
        {/* print, download section */}
        <Col
          md={24}
          lg={24}
          sm={24}
          xs={24}
          className={
            windowDimensions.height > 700 &&
            windowDimensions.height < 830 &&
            expensesDataTable.length > 0
              ? "mt-[5px] h-[100%] bg-[#ffffff] rounded-md"
              : windowDimensions.height > 830 && expensesDataTable.length > 0
              ? "mt-[7px] h-[100%] bg-[#ffffff] rounded-md"
              : windowDimensions.height > 700 &&
                windowDimensions.height < 830 &&
                expensesDataTable.length == 0
              ? "mt-[15px] h-[100%] bg-[#ffffff] rounded-md"
              : windowDimensions.height > 830 && expensesDataTable.length == 0
              ? "mt-[15px] h-[100%] bg-[#ffffff] rounded-md"
              : "bg-[#ffffff] h-[100%] rounded-md"
          }
        >
          <Row className="flex flex-col">
            <Col md={24} lg={24} sm={24} xs={24} className="mt-4 mb-3 pb-5">
              <Row className="flex justify-between">
                <Col
                  md={10}
                  lg={10}
                  sm={18}
                  xs={18}
                  className="pr-3 lg:pr-0 md:pr-0 pl-4"
                >
                  {loading ? (
                    <Skeleton.Input
                      style={{
                        width:
                          media == "md"
                            ? "180px"
                            : media == "sm"
                            ? "300px"
                            : "180px",
                        height: "35px",
                      }}
                    ></Skeleton.Input>
                  ) : (
                    <div className="w-[100%] lg:w-[65%] md:w-[65%]">
                      <AutoComplete
                        style={{
                          marginRight: "10px",
                          fontSize: "11px",
                        }}
                        // onClick={() => setSearchOpen(false)}
                        className="w-[100%]"
                      >
                        <Input.Search
                          size="middle"
                          placeholder="Search Category"
                          style={{
                            fontFamily: "Poppins",
                            // minHeight: "35px",
                            fontSize: "11px",
                          }}
                          name="search"
                          value={search}
                          onChange={(e) => handleSearch(e)}
                        />
                      </AutoComplete>
                    </div>
                  )}
                </Col>
                <Col md={14} lg={14} sm={18} xs={18} className="pr-1">
                  <Row className="flex justify-end">
                    <Col
                      md={7}
                      lg={7}
                      sm={24}
                      xs={24}
                      className="pr-3 sm:pr-3 ml-3 sm:ml-3 mt-3 lg:mt-0 md:mt-0 lg:ml-10 md:ml-10"
                    >
                      {loading ? (
                        <Skeleton.Input
                          style={{
                            width:
                              media == "md"
                                ? "180px"
                                : media == "sm"
                                ? "300px"
                                : "180px",
                            paddingRight: media == "md" ? "20px" : "14px",
                            marginLeft:
                              media == "sm" || media == "xs" ? "20px" : "0px",
                            height: "35px",
                          }}
                        ></Skeleton.Input>
                      ) : (
                        <Row>
                          <Col
                            md={24}
                            lg={24}
                            sm={24}
                            xs={24}
                            onClick={handleDownloadPDF}
                            className={
                              media == "sm" || media == "xs"
                                ? "cursor-pointer border pt-[5px] pb-[5px] ml-3 mr-2 rounded-md border-1"
                                : // ? "cursor-pointer border pt-[5px] pb-[5px] ml-3 mr-2 rounded-md border-1"
                                  "cursor-pointer border pt-[5px] pb-[5px] rounded-md border-1"
                              // : "cursor-pointer border pt-[5px] pb-[5px] sm:pl-[5px] md:pl-[10px] pl-[5px] lg:pl-[40px] xl:pl-[40px] xxl:pl-[40px] pr-[30px] rounded-md border-1"
                            }
                            style={{
                              fontFamily: "Poppins",
                            }}
                          >
                            {downloadLoading ? (
                              <p className="flex">
                                {" "}
                                <Spin className="mr-2" /> Downloading
                              </p>
                            ) : (
                              <p
                                className={
                                  media == "sm" || media == "xs"
                                    ? "flex justify-center"
                                    : "flex justify-center"
                                }
                              >
                                <DownloadOutlined className="text-[16px] mr-3" />{" "}
                                Download
                              </p>
                            )}
                          </Col>
                        </Row>
                      )}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>

            <Col
              span={24}
              className={
                media === "xxl"
                  ? "pt-8 pl-4 purchase-invoice-orders pb-12 pr-4"
                  : media === "md"
                  ? "mt-[-10px] pl-4 purchase-invoice-orders pb-12 pr-4"
                  : "pt-1 pl-4 purchase-invoice-orders pb-12 pr-4"
              }
            >
              <Table
                style={{
                  overflow: "hidden",
                }}
                bordered
                columns={HeaderData}
                dataSource={
                  expenseRows &&
                  expenseRows.length > 0 &&
                  !isEmpty(expenseRows[0]._id)
                    ? expenseRows
                    : []
                }
                rowClassName={"p-0"}
                expandable={{
                  // expandedRowRender: expandedRowRender,
                  defaultExpandAllRows: false,
                  // expandIconColumnIndex: 5,
                }}
                pagination={{
                  defaultPageSize: 10,
                  showSizeChanger: true,
                  // onShowSizeChange: (e) => console.log(e, "page limit"),
                  pageSizeOptions: ["5", "10", "20", "30"],
                  onChange: (e) => handlePagination(e),
                  // page
                  total: !isEmpty(search)
                    ? expenseRows.length
                    : expenses_report_list
                    ? expenses_report_list.totalItems
                    : "",
                }}
                sortDirections={"ascend"}
                loading={tableLoading ? true : false}
                showSorterTooltip={"sorter-icon"}
                scroll={{
                  y: "100%",
                  x: expensesDataTable.length > 0 ? 825 : "100%",
                }}
              />
            </Col>
          </Row>
        </Col>
      </Row>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        // closeOnClick
        rtl={false}
        // pauseOnFocusLoss
        // draggable
        style={{
          fontSize: "12px",
        }}
        // pauseOnHover
        theme="dark"
      />
    </React.Fragment>
  );
};

ExpensesReport.propTypes = {
  location: PropTypes.any,
  itemId: PropTypes.any,
  organizationId: PropTypes.any,
  partyName: PropTypes.any,
  ledgerLoading: PropTypes.any,
};

export default ExpensesReport;
